import { render, staticRenderFns } from "./IconCubeSolid.vue?vue&type=template&id=486a56d6"
import script from "./IconCubeSolid.vue?vue&type=script&lang=js"
export * from "./IconCubeSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports